import { trendingWords, siteName } from "@/mocks/gossip";

const stats = [
  { value: "2.4w+", label: "今日围观人次" },
  { value: "186", label: "今日新鲜瓜" },
  { value: "3.8w", label: "累计吃瓜讨论" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* 装饰底色 */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_520px_at_78%_-10%,#ffe0dc_0%,rgba(255,224,220,0)_60%),radial-gradient(900px_460px_at_8%_110%,#dbf3e0_0%,rgba(219,243,224,0)_60%)]"
      ></div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-16 top-10 hidden opacity-90 lg:block"
      >
        <span className="animate-float flex h-40 w-40 items-center justify-center rounded-[3rem] bg-background-200/80 text-background-500">
          <i className="ri-community-line text-6xl"></i>
        </span>
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-10 bottom-0 hidden rotate-12 opacity-90 lg:block"
      >
        <span className="animate-float flex h-28 w-28 items-center justify-center rounded-full bg-accent-200 text-accent-800 [animation-delay:1.4s]">
          <i className="ri-chat-3-line text-4xl"></i>
        </span>
      </div>

      <div className="relative mx-auto flex max-w-6xl flex-col items-center px-4 py-14 text-center md:px-6 md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700">
          <span className="animate-ring h-2 w-2 rounded-full bg-primary-500"></span>
          校园吃瓜爆料 · 实时新鲜事追踪
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight tracking-wide text-foreground-950 md:text-5xl">
          从课堂到宿舍，把校园里的
          <span className="relative mx-1 inline-block text-primary-600">
            新鲜事
            <span
              aria-hidden="true"
              className="absolute -bottom-1 left-0 h-2 w-full rounded-full bg-accent-200"
            ></span>
          </span>
          一网打尽
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {siteName} 汇集今日瓜速递与热门榜，专注校园八卦新鲜事与校内事件追踪。想追热点、看吃瓜爆料墙，来这就够了——最新鲜的瓜和热腾腾的讨论，每天为你端上桌。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#hot-rank"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-fire-fill"></i>
            看今日热搜榜
          </a>
          <a
            href="#fresh"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3.5 text-sm font-medium text-foreground-800 transition hover:border-foreground-400 hover:bg-background-100 sm:w-auto"
          >
            <i className="ri-flashlight-fill"></i>
            刷校园新鲜事
          </a>
        </div>

        {/* 热词 */}
        <div className="mt-8 flex w-full max-w-3xl flex-wrap items-center justify-center gap-2">
          {trendingWords.map((w) => (
            <a
              key={w}
              href="#topics"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600 transition hover:bg-background-200 hover:text-primary-700"
            >
              <i className="ri-price-tag-3-line text-[10px] text-accent-600"></i>
              {w}
            </a>
          ))}
        </div>

        {/* 数据 */}
        <dl className="mt-10 grid w-full max-w-2xl grid-cols-3 divide-x divide-background-200 rounded-2xl border border-background-200 bg-background-50/70 px-2 py-5 shadow-soft">
          {stats.map((s) => (
            <div key={s.label} className="px-2 text-center">
              <dt className="order-2 mt-1 block text-[11px] text-foreground-500">
                {s.label}
              </dt>
              <dd className="order-1 font-heading text-xl font-bold text-primary-600 md:text-2xl">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}